export const env = {
  appEnv: import.meta.env.VITE_APP_ENV,
  appVersion: __APP_VERSION__,
  apiUrl: import.meta.env.VITE_API_URL,
  publicApiUrl: import.meta.env.VITE_PUBLIC_API_BASE_URL,
  region: import.meta.env.VITE_REGION,
  cognito: {
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
  },
  isDev: import.meta.env.VITE_APP_ENV === "development",
  isProd: import.meta.env.VITE_APP_ENV === "production",
} as const;
